var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgObsidian = function SvgObsidian(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2055_56871)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2055_56871)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.3905 0L20.1025 11.2128L11.8401 29.088L24.3649 57.9008L42.1441 64L45.4017 57.472L52.1601 16.8896L40.3905 0Z",
    fill: "#34208C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1601 16.8896L39.6417 9.22241L22.3553 22.848L42.1441 64L45.4017 57.472L52.1601 16.8896Z",
    fill: "url(#paint0_linear_2055_56871)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1601 16.8896L40.3905 0L39.6417 9.2224L52.1601 16.8896Z",
    fill: "#AF9FF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6417 9.2224L40.3905 0L20.1025 11.2128L22.3553 22.848L39.6417 9.2224Z",
    fill: "#4A37A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3553 22.848L24.3649 57.9008L42.1441 64L22.3553 22.848Z",
    fill: "#4A37A0"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2055_56871",
    x1: 50.5217,
    y1: 51.5584,
    x2: 30.3041,
    y2: 3.24481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C56CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9785E5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2055_56871"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2055_56871"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.32,
    height: 64,
    fill: "white",
    transform: "translate(11.8401)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgObsidian);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iNjQiIHZpZXdCb3g9IjAgMCA2NCA2NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzIwNTVfNTY4NzEpIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAxXzIwNTVfNTY4NzEpIj4KPHBhdGggZD0iTTQwLjM5MDUgMEwyMC4xMDI1IDExLjIxMjhMMTEuODQwMSAyOS4wODhMMjQuMzY0OSA1Ny45MDA4TDQyLjE0NDEgNjRMNDUuNDAxNyA1Ny40NzJMNTIuMTYwMSAxNi44ODk2TDQwLjM5MDUgMFoiIGZpbGw9IiMzNDIwOEMiLz4KPHBhdGggZD0iTTUyLjE2MDEgMTYuODg5NkwzOS42NDE3IDkuMjIyNDFMMjIuMzU1MyAyMi44NDhMNDIuMTQ0MSA2NEw0NS40MDE3IDU3LjQ3Mkw1Mi4xNjAxIDE2Ljg4OTZaIiBmaWxsPSJ1cmwoI3BhaW50MF9saW5lYXJfMjA1NV81Njg3MSkiLz4KPHBhdGggZD0iTTUyLjE2MDEgMTYuODg5Nkw0MC4zOTA1IDBMMzkuNjQxNyA5LjIyMjRMNTIuMTYwMSAxNi44ODk2WiIgZmlsbD0iI0FGOUZGNCIvPgo8cGF0aCBkPSJNMzkuNjQxNyA5LjIyMjRMNDAuMzkwNSAwTDIwLjEwMjUgMTEuMjEyOEwyMi4zNTUzIDIyLjg0OEwzOS42NDE3IDkuMjIyNFoiIGZpbGw9IiM0QTM3QTAiLz4KPHBhdGggZD0iTTIyLjM1NTMgMjIuODQ4TDI0LjM2NDkgNTcuOTAwOEw0Mi4xNDQxIDY0TDIyLjM1NTMgMjIuODQ4WiIgZmlsbD0iIzRBMzdBMCIvPgo8L2c+CjwvZz4KPGRlZnM+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQwX2xpbmVhcl8yMDU1XzU2ODcxIiB4MT0iNTAuNTIxNyIgeTE9IjUxLjU1ODQiIHgyPSIzMC4zMDQxIiB5Mj0iMy4yNDQ4MSIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcCBzdG9wLWNvbG9yPSIjNkM1NkNDIi8+CjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzk3ODVFNSIvPgo8L2xpbmVhckdyYWRpZW50Pgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzIwNTVfNTY4NzEiPgo8cmVjdCB3aWR0aD0iNjQiIGhlaWdodD0iNjQiIGZpbGw9IndoaXRlIi8+CjwvY2xpcFBhdGg+CjxjbGlwUGF0aCBpZD0iY2xpcDFfMjA1NV81Njg3MSI+CjxyZWN0IHdpZHRoPSI0MC4zMiIgaGVpZ2h0PSI2NCIgZmlsbD0id2hpdGUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDExLjg0MDEpIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==";